import EdFormControl from '@Components/UI/Inputs/EdFormControl/EdFormControl';
import EdIcon from '@Components/UI/Utilities/EdIcon/EdIcon';
import { useTypedSelector } from '@Features/store';
import { yupResolver } from '@hookform/resolvers/yup';
import { AppBar, IconButton, InputAdornment } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useController, useForm } from 'react-hook-form';
import { object, string } from 'yup';
import { Test } from '../../../Types/Test/Test.types';
import { cloneDeep } from 'lodash';
import { DevTool } from '@hookform/devtools';
import EdAnimatedIcon from '@Components/UI/Utilities/EdAnimatedIcon/EdAnimatedIcon';
import { FlexLayout, Spacer } from '@Styled/utilities';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import TestQuestionsTable from '../Components/TestQuestionsTable';
import MCQ from '../Components/Questions/MCQ/MCQ';
import EditMCQ from '../Components/Questions/MCQ/EditMCQ/EditMCQ';
import Ordering from '../Components/Questions/Ordering/Ordering';
import EditOrdering from '../Components/Questions/Ordering/EditOrdering';
import TagsModal from '../Components/TagsModal/TagsModal';
import {
	RouteProvider,
	useRouteProvider,
} from '@Providers/Routes/RoutesProvider';
import EssayQuestion from './EssayQuestion';
import GapQuestion from './GapQuestion/GapQuestion';
const SCHEMA = object({
	name: string(),
});
// const GapQuestion = React.lazy(() => import('./GapQuestion/GapQuestion'));

const TestQuestions = () => {
	const { path } = useRouteMatch();
	return (
		<>
			<RouteProvider path={path}>
				<React.Suspense fallback={<div>loading</div>}>
					<Switch>
						<Route path={`${path}`} exact>
							<TestQuestionsTable />
						</Route>
						<Route path={`${path}/tags`}>
							<TagsModal />
						</Route>
						{/*
						  Distinct keys, because both routes render the same component
						  from the same position in the Switch: React would otherwise
						  reuse the instance across an mcq -> mrq navigation, and
						  react-hook-form reads defaultValues once at mount, so the
						  form would keep registering the type it first opened with.
						  The add-question menu is a persistent sidebar, so switching
						  without leaving the form is the normal path, not an edge case.
						*/}
						<Route path={`${path}/mcq`} exact>
							<MCQ key="create-mcq" />
						</Route>
						<Route path={`${path}/mrq`} exact>
							<MCQ key="create-mrq" type="mrq" />
						</Route>
						<Route path={`${path}/mcq/:id`} exact>
							<EditMCQ />
						</Route>
						<Route path={`${path}/mrq/:id`} exact>
							<EditMCQ />
						</Route>
						<Route path={`${path}/gap`}>
							<GapQuestion />
						</Route>
						<Route path={`${path}/essay`}>
							<EssayQuestion />
						</Route>
						<Route path={`${path}/ordering`} exact>
							<Ordering />
						</Route>
						<Route path={`${path}/ordering/:id`} exact>
							<EditOrdering />
						</Route>
					</Switch>
				</React.Suspense>
			</RouteProvider>
		</>
	);
};

export default TestQuestions;
